/* eslint-disable indent */

const ProgressBar = ({ progress, message, height = '8px', width = '100%' }) => (
  <>
    <div className='w-full bg-gray-sa100 dark:bg-gray-130 rounded-full  overflow-hidden' style={{ height: `${height}`, width: `${width}` }}>
      <div className="striped-background h-4 rounded-full" style={{ width: `${progress}%`, height: `${height}` }}>
      </div>
    </div>
    {message}
  </>
);

export default ProgressBar;
